import { useEffect, useState } from "react";
import { selectEntryChannelsLoadingPag, selectEntryChannelsPag } from "../../redux/entryChannels/selectors";
import { AdminTable } from "./AdminTable";
import { useDispatch, useSelector } from "react-redux";
import { Column } from "devextreme-react/data-grid";
import { createEntryChannel, deleteEntryChannel, editEntryChannel, getEntryChannelsPag } from "../../redux/entryChannels/thunks";
import { openModal } from "../../redux/modal/modalSlice";
import { selectBrandPagedList, selectBrandPagedListLoading } from "../../redux/brands/selectors";
import { getBrandsPag } from "../../redux/brands/thunks";
import { selectModelPagedList, selectModelPagedListLoading } from "../../redux/models/selectors";
import { createModel, deleteModel, getModelsPag, updateModel } from "../../redux/models/thunks";
import { formatToCurrency, formatToPercentage } from "../../commonFunctions/FormatterFunctions";


const initialSortOptions = {
    columna: "brandId",
    sortOrderAsc: true

}

function BrandModelManagement() {
    const models = useSelector(selectModelPagedList);
    const dispatch = useDispatch();
    const loading = useSelector(selectModelPagedListLoading);
    const [sortOptions, setSortOptions] = useState(initialSortOptions)
    

    useEffect(()=>{
        getListModels(mapPageInfo(models));
    }, [])

    function mapPageInfo(modelsData){
        return {
            pageIndex: modelsData.pageIndex ?? 0,
            pageSize: modelsData.pageSize ?? 10,
            orderByField:  modelsData.columna ?? "ModelId",
            orderByAscending:  modelsData.sortOrderAsc ?? true
        }
    }
      
    const getListModels = (pageInfo) => {
        let query = `?pageIndex=${pageInfo.pageIndex}&pageNum=${pageInfo.pageSize}`
        if(pageInfo.searchString?.trim().length > 0){
            query = query.concat(`&searchString=${pageInfo.searchString.trim()}`)
        }
        if(pageInfo.orderByField)
            {
                query = query.concat(`&orderByField=${pageInfo.orderByField}&orderByAscending=${pageInfo.orderByAscending}`)
            }
        dispatch(getModelsPag({query}));
    }

    const columnsEntryChannels = [
        <Column sortIndex={1} width={"5%"}  key={"model-1"} dataField="modelId" caption="Id" allowEditing={false} allowCreating={false}/>, 
        <Column sortIndex={1} key={"model-2"} dataField="brandName" caption="Montadora" allowEditing={false} allowCreating={false}/>, 
        <Column key={"model-3"} dataField="modelName" caption="Nome" />, 
        <Column key={"model-4"} dataField="year" caption="Ano/Modelo" />,

        <Column key={"model-5"} dataField="publicPrice" calculateDisplayValue={(e)=> formatToCurrency(e.publicPrice)} caption="Preço Público" />,
        <Column key={"model-6"} dataField="discount" calculateDisplayValue={(e)=> formatToPercentage(e.discount)} caption="Desconto" />,
        <Column key={"model-7"} dataField="finalPrice" calculateDisplayValue={(e)=> formatToCurrency(e.finalPrice)} caption="Valor Final" />,

        // {
        //     "modelId": 954,
        //     "modelName": "TITANO RANCH TURBODIESEL 4X4 AT 24/25",
        //     "att": "2025-05-07T00:00:00",
        //     "year": "24/25",
        //     "publicPrice": 259990.00,
        //     "discount": 0.21,
        //     "finalPrice": 205392.10,
        //     "billing": "45 A 60 DIAS",
        //     "category": "PICAPE",
        //     "engine": null,
        //     "gearbox": null,
        //     "baseColors": "BRANCO",
        //     "solidColors": null,
        //     "solidColorsPrice": null,
        //     "metalicColors": null,
        //     "metalicColorsPrice": null,
        //     "customColors": null,
        //     "customColorsPrice": null,
        //     "observations": null,
        //     "brandId": 179,
        //     "brandName": "FIAT"
        // },
    ] 

    function isValidFormData(data) {
        // if (data.name.trim() === '') {
        //   dispatch(openModal({ type: 'warning', message: 'Por favor, preencha o campo Nome' }));
        //   return false;
        // }
    
        return true;
      }
    
      function handleSaveNewEntryChannelClick(value, closeCreateModal) {
        if(!isValidFormData(value))
            return;
    
        const brandParams = { body: value };
        dispatch(createModel(brandParams)).then((data) => {
          if (data.error) dispatch(openModal({ type: 'warning', message: data.error.message }));
          else {
            getListModels(mapPageInfo({ ...models, ...sortOptions }));
            closeCreateModal();
          }
        });
      }
    
      const handleEditClick = (value, closeEditModal) => {
        if(!isValidFormData(value))
            return;
    
        const params = {
          param: value.brandId,
          body: value,
        };
    
        dispatch(updateModel(params)).then((data) => {
          if (data.error) dispatch(openModal({ type: 'warning', message: data.error.message }));
          else {
            dispatch(openModal({ type: 'success', message: 'Modelo atualizado com sucesso!' }));
            getListModels(mapPageInfo({ ...models, ...sortOptions }));
            closeEditModal();
          }
        });
      };
    
      const handleDeleteClick = (id, closeDeleteModal) => {
        dispatch(deleteModel({ param: id })).then((data) => {
          if (data.error) dispatch(openModal({ type: 'warning', message: data.error.message }));
          else {
            dispatch(openModal({ type: 'success', message: 'Modelo excluído com sucesso!' }));
    
            let updatedPageIndex = models.pageIndex;
    
            if (models.elements.length === 1) {
              updatedPageIndex = Math.max(0, models.pageIndex - 1);
            }
    
            const updatedModels = {
              ...models,
              pageIndex: updatedPageIndex,
            };
    
            getListModels(mapPageInfo({ ...updatedModels, ...sortOptions }));
            closeDeleteModal();
          }
        });
      };

    function allowDelete(rowData){
        return true;
        //return rowData.data.custom;
    }

    return(
        <div style={{width: "100%"}}>
            <AdminTable
                sectionTitle={"Modelo"} 
                masterTitle={"modelo"} 
                itemIdField={"modelId"} 
                itemDescriptionField={"modelName"} 
                loading={loading} 
                getData={getListModels} 
                dataSource={models} 
                columnasTabla={columnsEntryChannels} 
                onCreate={handleSaveNewEntryChannelClick}
                onDelete={handleDeleteClick}
                onEdit={handleEditClick} 
                numElements={[10, 20, 30]}
                allowDelete={allowDelete}
                sortField={sortOptions}
                setsortField={setSortOptions}
            />
        </div>
    )
}
export default BrandModelManagement;